import { CommonModule } from '@angular/common';
import { FormsModule, NgModel } from '@angular/forms';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { LoaderComponent } from './loader/loader.component';
import { PagingButtonsComponent } from './paging-buttons/paging-buttons.component';

export abstract class BasePage
{
    public static readonly BaseImports = [
        CommonModule,
        FormsModule,
        LoaderComponent,
        PagingButtonsComponent,
        RouterOutlet,
        RouterLink,
        RouterLinkActive
    ];
}
